import React, { useCallback } from 'react';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { Default } from '../../../layouts';
import { create } from '../../../services/support/suport-mobile-orders';
import SuportMobileOrder from '../../../components/support/SuportMobileOrderForm';

const initialData = {
  physicalId: null,
  accountId: null,
  products: [],
};

const MobileOrders = () => {
  const { t } = useTranslation();

  const handleSubmit = useCallback(
    (value) =>
      create(value)
        .then(() => {
          notification.success({ message: t('actions.saveSuccessful') });
          window.location.reload();
        })
        .catch((err) => {
          const messageCode = err?.inner?._;
          notification.error({
            message: messageCode
              ? t(messageCode, err.inner)
              : t('actions.saveFailed'),
          });
          throw err;
        }),
    [t],
  );

  const handleCancel = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <Default>
      <SuportMobileOrder
        data={initialData}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Default>
  );
};
export default MobileOrders;
